import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header"]
  static values = { overlay: Boolean }

  connect() {
    this.scrolled = null
    window.addEventListener("scroll", this.onScroll)
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll = () => {
    const isScrolled = window.scrollY > 8
    if (isScrolled === this.scrolled) return
    this.scrolled = isScrolled

    const el = this.headerTarget
    if (isScrolled) {
      el.style.background = "rgba(246,241,232,.82)"
      el.style.backdropFilter = "saturate(140%) blur(12px)"
      el.style.WebkitBackdropFilter = "saturate(140%) blur(12px)"
      el.style.borderBottomColor = "#E3DACB"
      if (this.overlayValue) el.classList.remove("nav-light")
    } else {
      el.style.background = this.overlayValue ? "transparent" : "#F6F1E8"
      el.style.backdropFilter = "none"
      el.style.WebkitBackdropFilter = "none"
      el.style.borderBottomColor = "transparent"
      if (this.overlayValue) el.classList.add("nav-light")
    }
  }
}
